import './multi-move-dns-zone-action.scss';

export class MoleculePanelOverviewHeaderMultiMoveDnsZoneActionComponent {
    public templateUrl = require('./multi-move-dns-zone-action.html?external');
}
